import { useEffect, useState } from 'react';
import { FormInput } from '@practium/ui';

interface ValueInputProps {
	value: number | undefined;
	label: string;
	min?: number;
	max?: number;
	decimals?: number;
	suffix?: string;
	placeholder?: string;
	hasError?: boolean;
	onChange: (value: number | undefined) => void;
}

const toText = (value: number | undefined | null, decimals?: number) => {
	if (value === undefined || value === null) return '';
	return decimals === undefined ? String(value) : String(Number(value.toFixed(decimals)));
};

const parse = (text: string) => {
	if (text.trim() === '') return undefined;
	const parsed = Number(text);
	return Number.isFinite(parsed) ? parsed : undefined;
};

export const ValueInput = ({
	value,
	label,
	min = 0,
	max,
	decimals,
	suffix,
	placeholder,
	hasError,
	onChange,
}: ValueInputProps) => {
	const [text, setText] = useState(toText(value, decimals));

	useEffect(() => {
		setText((current) => (parse(current) === value ? current : toText(value, decimals)));
	}, [decimals, value]);

	return (
		<FormInput
			type="number"
			step="any"
			min={min}
			max={max}
			aria-label={label}
			suffix={suffix}
			placeholder={placeholder}
			hasError={hasError}
			value={text}
			onChange={(event) => {
				setText(event.target.value);
				onChange(parse(event.target.value));
			}}
		/>
	);
};
